import { themr } from '@friendsofreactjs/react-css-themr';

import ExpandableSection from './ExpandableSection';

export default themr('ExpandableSection')(ExpandableSection);
